import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { images } from "../../config/images";
import { getAutoclaveStationDetails } from "../ProductionLine/services";
import { toast } from "react-toastify";

const AutoClave = ({ setAutoClave, batchId }) => {
  const [autoClaveData, setAutoClaveData] = useState([]);

  useEffect(() => {
    handleGetAutoClave();
  }, [batchId]);

  const handleGetAutoClave = async () => {
    try {
      const resp = await getAutoclaveStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setAutoClaveData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setAutoClaveData([]);
      console.log("handlesubmit", error);
    }
  };

  return (
    <>
      <div className="modal-container" style={{ height: "40vh", top: "35vh" }}>
        <div className="modal-header">
          <div className="modal-title">AUTOCLAVE PROCESS SHEET</div>
          <div
            onClick={() => setAutoClave(false)}
            style={{ cursor: "pointer" }}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="modal-table-wrapper">
          <div
            style={{
              width: "100%",
              overflow: "auto",
              maxHeight: "400px",
            }}
            className="gloves-report-data"
          >
            <Table className="dipping-params">
              <TableHead>
                <TableRow>
                  <TableCell>Max Pressure</TableCell>
                  <TableCell>Min Pressure</TableCell>
                  <TableCell>Max Temp(°C)</TableCell>
                  <TableCell>Min Temp(°C)</TableCell>
                  <TableCell>Time (Minutes)</TableCell>
                  <TableCell>Cycle Start Time</TableCell>
                  <TableCell>Cycle End Time</TableCell>
                  <TableCell>Operator</TableCell>
                  <TableCell>Supervisor</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="gloves-report-body">
                {autoClaveData?.map((e) => {
                  return (
                    <TableRow>
                      <TableCell>
                        {e.max_pressure ? e.max_pressure : "--"}
                      </TableCell>
                      <TableCell>
                        {e.min_pressure ? e.min_pressure : "--"}
                      </TableCell>
                      <TableCell>{e.max_temp ? e.max_temp : "--"}</TableCell>
                      <TableCell>{e.min_temp ? e.min_temp : "--"}</TableCell>
                      <TableCell>
                        {e.cycle_time_minutes ? e.cycle_time_minutes : "--"}
                      </TableCell>

                      <TableCell>
                        {e
                          ? e?.cycle_start_time
                            ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_end_time
                            ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>{e.operator ? e.operator : "--"}</TableCell>
                      <TableCell>
                        {e.supervisor ? e.supervisor : "--"}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
      <div className="modal-overlay" onClick={() => setAutoClave(false)}></div>
    </>
  );
};

export default AutoClave;
